import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherCreate_EditPage_Mutation = graphql(/* GraphQL */ `
	mutation VoucherCreate_EditPage($input: VoucherInput!) {
		voucherCreate(input: $input) {
			userErrors
			voucher {
				id
				hotelID
				voucherID
				inSale
				name
				description
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				voucherPrice {
					currencyType
					amount
				}
				sellingPrice {
					currencyType
					amount
				}
				saleTypeForTerm
				saleStart
				saleEnd
				maxStockNum
				soldNumTotal
				voucherLimitType
				intervalPrepDates
				cinStart
				cinEnd
				deletedAt
			}
		}
	}
`);
